import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileCabinetFormsService {

  private dataSource = new BehaviorSubject(null);
  updatedFormsEvent: Subject<any> = new Subject();
  
  constructor(
    private _http: HttpClient
  ) { }

  refreshCount(data: any[]) {
    this.dataSource.next(data);
  }
  
  getFileCabinetForms(organizationId, actionType) {
    let endPoint = `${environment.url}/forms/${organizationId}/${actionType}?from=filecabinet`
    // return this._http.get(environment.url + "/forms/" + organizationId + "/" + actionType + "?from=filecabinet");
    return this._http.get(endPoint)
  }

  restoreFileCabinetForms(requestData) {
    return this._http.put(environment.url + "/forms/flagged/restore", requestData);
  }

  updateFileCabinetForms(forms) {
    this.updatedFormsEvent.next(forms)
  }
}
